export default "__VITE_ASSET__576e5d63__"